<template>
  <v-container class="customscroll fill-height ma-0 pa-0" fluid style="height: 100vh; height: 100dvh; overflow-x: hidden; overflow-y: auto">
    <!-- <t-background style="min-height: 6500px; "></t-background> -->
    <!-- <t-background noautoheight style="min-height: 6500px"></t-background> -->
    <t-background noautoheight style="position: absolute; min-height: 5500px; top: -3600px; width: 1920px"></t-background>
    <v-dialog v-model="dialogFDRID" width="400">
      <v-card class="ma-0 pa-1" width="400" height="270" style="position: relative">
        <v-btn fab x-small @click="dialogFDRID = false" style="position: absolute; z-index: 999; top: 2px; right: 2px">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
        <span style="background: white; position: absolute; text-align: center; left: 0px; right: 0px; bottom: 0px; z-index: 999">FDRID е вписан в паспорта на ФУ, стр.6</span>
        <v-img :src="imageFDRID" contain width="400" height="260"></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAgreement" persistent :width="isOnMobile ? '90%' : '80%'">
      <div class="ma-0 pa-0 customscroll" style="width: 100%" :style="isWithSmallWidth ? 'height: 500px' : 'height: 600px'">
        <v-card :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-6'" width="100%">
          <div class="ma-0 pa-0 mb-4" v-html="isInDarkMode ? agreementContent.replaceAll('color: rgb(0, 0, 0);', 'color: rgb(255, 255, 255);') : agreementContent"></div>
          <v-row class="ma-0 pa-0" align="center" justify="end">
            <v-card align="center" justify-self="center" max-width="40%" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'error'" class="ma-2 pa-2 no-text-transform white--text" @click="cancelDialog(false)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ s_IDoNotAgree }}</span>
            </v-card>
            <v-card align="center" justify="center" max-width="40%" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="Colors.IconColor" class="ma-2 pa-2 no-text-transform white--text" @click="cancelDialog(true)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ s_IAgree }}</span>
            </v-card>
          </v-row>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-if="dialogGoToLogin" v-model="dialogGoToLogin" :overlay-opacity="0.77" persistent max-width="400" style="z-index: 9999999">
      <v-card>
        <v-card-title>{{ s_Attention }}</v-card-title>
        <v-card-actions class="mx-4">
          <span style="text-align: justify">{{ s_RegistrationDataAvailable }}</span>
        </v-card-actions>
        <v-card-actions class="mx-4">
          <span style="text-align: justify">{{ s_RegistrationCancelConfirm }}</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogGoToLogin = false" color="warning" tile>{{ s_No }}</v-btn>
          <v-btn @click="goToLogin(true)" color="success" tile>{{ s_Yes }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogChooseType" v-model="dialogChooseType" :overlay-opacity="0.77" persistent max-width="500" style="z-index: 9999999">
      <v-card>
        <v-card-actions class="ma-0 pa-0 pt-4">
          <v-col>
            <v-row aling="center" justify="center" class="pb-3">
              <span :class="isOnMobile ? 'lndtitle' : 'lndtitlelarge'" style="z-index: 10">
                <span class="lndlogo">TREMOL</span>
                <span class="lndtrademark">®</span>
                <span class="lndlogoassistant">Assistant</span>
              </span>
            </v-row>
          </v-col>
        </v-card-actions>
        <v-card-actions>
          <v-col class="ma-0 pa-0">
            <v-row align="center" justify="center" class="ma-0 pa-0" v-for="(t, idx) in tabs" :key="idx">
              <v-tooltip :disabled="isOnMobile" right class="ma-0 pa-0" content-class="primary tooltip-right custom-tooltip" :close-delay="0" :open-delay="333">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ma-2 pa-2 white--text" block :color="Colors.IconColor" @click="selectTab(idx)">
                    <v-icon left>{{ t.icon }}</v-icon>
                    <span style="white-space: pre-wrap">{{ t.name }}</span>
                  </v-btn>
                </template>
                <span style="max-width: 300px">{{ t.description }}</span>
              </v-tooltip>
            </v-row>
            <v-row justify="space-around" class="ma-0 pa-0">
              <v-btn text class="font-weight-black" @click="goToLogin()" :color="Colors.IconColor">{{ s_Cancel }}</v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card v-if="isOnMobile" class="ma-0 pa-0 box-container">
      <v-card-title class="ma-0 pa-0 row-header">
        <div class="box-container-horizontal">
          <v-tabs align-with-title centered show-arrows center-active fixed-tabs height="60">
            <v-tab class="row-content" @click="dialogChooseType = true">
              <v-icon large>{{ tabs[currentTab].icon }}</v-icon>
              <span>{{ tabs[currentTab].name }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 row-content">
        <v-form ref="refRegistrationForm" v-model="valid" lazy-validation>
          <v-row justify="center" class="ma-0 pa-0">
            <v-col cols="10" sm="10" md="10" class="pa-2" style="text-align: justify; text-justify: inter-word">
              <span style="font-style: italic">{{ "* " + tabs[currentTab].description }}</span>
            </v-col>
            <v-col cols="10" sm="10" md="5" xs="12" class="pa-2">
              <v-text-field class="ma-0 pa-0" v-model="user.username" :label="s_Username" name="username" autocomplete="username" :rules="[...global_rules.required, ...global_rules.username]" type="text" required />
            </v-col>
            <v-col cols="10" sm="10" md="5" xs="12" class="pa-2">
              <v-text-field class="ma-0 pa-0" v-model="user.email" autocomplete="email" name="email" :label="s_Email" :rules="global_rules.required" required />
            </v-col>
            <v-col cols="10" sm="10" md="5" class="pa-2">
              <v-text-field
                class="ma-0 pa-0"
                v-model="user.password"
                @keydown="isCapsOn"
                :type="show1 ? 'text' : 'password'"
                name="password"
                autocomplete="new-password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :label="TR.Password"
                :hint="TR.PasswordMin6Symbols"
                counter
                @click:append="show1 = !show1"
                :rules="[...global_rules.required, rules.minPassLen]"
              >
                <CapsTooltip v-if="capsOn" slot="append-outer" />
              </v-text-field>
            </v-col>
            <v-col cols="10" sm="10" md="5" class="pa-2">
              <v-text-field
                class="ma-0 pa-0"
                v-model="user.confirmpassword"
                @keydown="isCapsOn"
                :type="show1 ? 'text' : 'password'"
                name="passwordConfirm"
                autocomplete="new-password"
                :label="TR.ConfirmPassword"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                counter
                @click:append="show1 = !show1"
                :rules="[...global_rules.required, rules.minPassLen]"
              >
                <CapsTooltip v-if="capsOn" slot="append-outer" />
              </v-text-field>
            </v-col>
            <template v-if="currentTab == 2">
              <v-col cols="10" sm="10" md="4" class="pa-2">
                <v-text-field v-model="user.EIK" :label="s_EIK" name="eik" type="text" class="ma-0 pa-0" :rules="[...global_rules.required, ...global_rules.validEIK]" />
              </v-col>
              <v-col cols="10" sm="10" md="6" class="pa-2">
                <v-text-field v-model="user.FALicense" label="ФУВАС Администратор лиценз" name="falicense" :rules="global_rules.required" type="text" class="ma-0 pa-0" />
              </v-col>
              <v-col cols="10" sm="10" md="4" class="pa-2">
                <v-text-field v-model="user.FAOldPsw" label="ФУВАС Админ парола" name="fapassword" :rules="global_rules.required" type="text" class="ma-0 pa-0" />
              </v-col>
            </template>
            <template v-if="currentTab == 0">
              <v-col cols="10" sm="10" md="4" class="pa-2">
                <v-text-field v-model="user.eikSNFDrid.eik" class="ma-0 pa-0" :label="s_EIK" name="eik" type="text" :rules="[...global_rules.required, ...global_rules.validEIK]" required />
              </v-col>
              <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
                <v-text-field v-model="user.eikSNFDrid.sn" class="ma-0 pa-0" :label="s_DevSN" name="sn" type="text" :rules="global_rules.required" />
              </v-col>
              <v-col cols="10" sm="10" md="2" xs="12" class="pa-2">
                <v-text-field v-model="user.eikSNFDrid.fdrid" class="ma-0 pa-0" :label="s_FDRID" name="fDrid" type="text" :rules="global_rules.required" append-icon="mdi-help-circle-outline" @click:append="dialogFDRID = true" />
              </v-col>
            </template>
            <template v-if="currentTab == 1">
              <v-col cols="10" sm="10" md="6" xs="12" class="pa-2">
                <v-text-field v-model="user.oCuserCompanyName" :label="s_CompanyName" name="oCuserCompanyName" type="text" class="ma-0 pa-0" :rules="global_rules.required" />
              </v-col>
              <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
                <v-text-field v-model="user.EIK" :label="s_EIK" name="eik" type="text" class="ma-0 pa-0" :rules="[...global_rules.required, ...global_rules.validEIK]" />
              </v-col>
            </template>
            <v-col cols="10" sm="10" md="10" xs="12" class="pa-2 pb-0">
              <v-card-text class="ma-0 pa-0 text-start subtitle-1" readonly hide-details single-line label>{{ s_MOLorAuthorizedPerson + ":" }}</v-card-text>
            </v-col>
            <v-col cols="10" sm="10" md="3" xs="12" class="pa-2">
              <v-text-field class="ma-0 pa-0" v-model="user.firstname" :label="s_Name" name="FirstName" :rules="global_rules.required" maxlength="30" required />
            </v-col>
            <v-col cols="10" sm="10" md="3" xs="12" class="pa-2">
              <v-text-field class="ma-0 pa-0" v-model="user.middlename" :label="s_Surname" name="MiddleName" :rules="global_rules.required" maxlength="30" required></v-text-field>
            </v-col>
            <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
              <v-text-field class="ma-0 pa-0" v-model="user.lastname" :label="s_LastName" name="LastName" :rules="global_rules.required" maxlength="30" required></v-text-field>
            </v-col>
            <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
              <v-row>
                <v-col cols="2">
                  <v-simple-checkbox class="pr-3" :color="Colors.IconColor" v-model="agree" @click="dialogAgreement = agree" name="Agree" :ripple="false"></v-simple-checkbox>
                </v-col>
                <v-col cols="10">
                  <span class="subtitle-1" style="cursor: pointer" @click="dialogAgreement = true">
                    {{ s_IAccept }}
                    <span style="border-bottom-width: 1px; border-bottom-style: solid">{{ s_TheTermsOfUse }}</span
                    >{{ " " + s_AndIAgree }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 row-header">
        <v-col cols="12">
          <v-btn block color="success" @click="register()" :disabled="wait_login_timeout">{{ s_Registration }}</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
    <v-row v-if="!isOnMobile" align="center" justify="center">
      <v-col cols="12" sm="10" md="9" lg="8" align="center" justify="center">
        <!-- <v-img contain width="auto" :max-width="500" height="auto" style="cursor: pointer" class="ma-0 pa-0" @click="openTremolSite()" :src="require('../../assets/img/tremollogo.png')"></v-img> -->
        <v-row aling="start" justify="center" style="cursor: pointer" @click="$router.push({ path: '/landing' })">
          <span class="lndtitlelarge" style="z-index: 10">
            <span class="lndlogo">TREMOL</span>
            <span class="lndtrademark">®</span>
            <span class="lndlogoassistant">Assistant</span>
          </span>
        </v-row>
        <v-card class="elevation-24 pa-0">
          <v-tabs v-model="currentTab" @change="selectTab(currentTab)" height="60" align-with-title centered show-arrows center-active class="ma-0 pa-0 mt-5" fixed-tabs>
            <v-tabs-slider :color="Colors.IconColor" class="ma-0 pa-0"></v-tabs-slider>
            <v-tab v-for="(t, idx) in tabs" :key="idx">
              <v-icon large>{{ t.icon }}</v-icon>
              <span>{{ t.name }}</span>
            </v-tab>
          </v-tabs>
          <v-card class="elevation-0">
            <v-card-text>
              <v-form ref="refRegistrationForm" v-model="valid" lazy-validation>
                <v-row justify="center" class="pt-4">
                  <v-col cols="10" sm="10" md="10" class="pa-2">
                    <span style="font-style: italic; white-space: pre-wrap">{{ "* " + tabs[currentTab].description }}</span>
                  </v-col>
                  <v-col cols="10" sm="10" md="5" xs="12" class="pa-2">
                    <v-text-field class="ma-0 pa-0" v-model="user.username" :label="s_Username" name="username" autocomplete="username" :rules="[...global_rules.required, ...global_rules.username]" type="text" required />
                  </v-col>
                  <v-col cols="10" sm="10" md="5" xs="12" class="pa-2">
                    <v-text-field class="ma-0 pa-0" v-model="user.email" :label="s_Email" name="email" autocomplete="email" :rules="[...global_rules.required, ...global_rules.email]" required />
                  </v-col>
                  <v-col cols="10" sm="10" md="5" class="pa-2">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model="user.password"
                      :label="TR.Password"
                      @keydown="isCapsOn"
                      :type="show1 ? 'text' : 'password'"
                      name="password"
                      autocomplete="new-password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :hint="TR.PasswordMin6Symbols"
                      counter
                      @click:append="show1 = !show1"
                      :rules="[...global_rules.required, rules.minPassLen]"
                    >
                      <CapsTooltip v-if="capsOn" slot="append-outer" />
                    </v-text-field>
                  </v-col>
                  <v-col cols="10" sm="10" md="5" class="pa-2">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model="user.confirmpassword"
                      @keydown="isCapsOn"
                      :label="TR.ConfirmPassword"
                      :type="show1 ? 'text' : 'password'"
                      name="passwordConfirm"
                      autocomplete="new-password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      counter
                      @click:append="show1 = !show1"
                      :rules="[...global_rules.required, rules.minPassLen]"
                    >
                      <CapsTooltip v-if="capsOn" slot="append-outer" />
                    </v-text-field>
                  </v-col>
                  <template v-if="currentTab == 2">
                    <v-row align="center" justify="center" class="ma-0 pa-0">
                      <v-col cols="10" sm="10" md="2" class="pa-2">
                        <v-text-field v-model="user.EIK" :label="s_EIK" name="eik" type="text" class="ma-0 pa-0" :rules="[...global_rules.required, ...global_rules.validEIK]" />
                      </v-col>
                      <v-col cols="10" sm="10" md="5" class="pa-2">
                        <v-text-field label="ФУВАС Администратор лицензен ключ" name="falicense" v-model="user.FALicense" :rules="global_rules.required" type="text" class="ma-0 pa-0" />
                      </v-col>
                      <v-col cols="10" sm="10" md="3" class="pa-2">
                        <v-text-field label="Парола за ФУВАС Администратор" name="fapassword" v-model="user.FAOldPsw" :rules="global_rules.required" type="text" class="ma-0 pa-0" />
                      </v-col>
                    </v-row>
                  </template>
                  <template v-if="currentTab == 0">
                    <v-col cols="10" sm="10" md="4" class="pa-2">
                      <v-text-field class="ma-0 pa-0" v-model="user.eikSNFDrid.eik" :label="s_EIK" name="eik" type="text" :rules="[...global_rules.required, ...global_rules.validEIK]" required />
                    </v-col>
                    <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
                      <v-text-field class="ma-0 pa-0" v-model="user.eikSNFDrid.sn" :label="s_DevSN" name="sn" type="text" :rules="global_rules.required" />
                    </v-col>
                    <v-col cols="10" sm="10" md="2" xs="12" class="pa-2">
                      <v-text-field class="ma-0 pa-0" v-model="user.eikSNFDrid.fdrid" :label="s_FDRID" name="fDrid" type="text" :rules="global_rules.required" append-icon="mdi-help-circle-outline" @click:append="dialogFDRID = true" />
                    </v-col>
                  </template>
                  <template v-if="currentTab == 1">
                    <v-col cols="10" sm="10" md="6" class="pa-2">
                      <v-text-field v-model="user.oCuserCompanyName" :label="s_CompanyName" name="oCuserCompanyName" type="text" class="ma-0 pa-0" :rules="global_rules.required" />
                    </v-col>
                    <v-col cols="10" sm="10" md="4" class="pa-2">
                      <v-text-field v-model="user.EIK" :label="s_EIK" name="eik" type="text" class="ma-0 pa-0" :rules="[...global_rules.required, ...global_rules.validEIK]" />
                    </v-col>
                  </template>
                  <v-col cols="10" sm="10" md="10" class="pa-2 pb-0">
                    <v-card-text class="ma-0 pa-0 text-start subtitle-1" readonly hide-details single-line label>{{ s_MOLorAuthorizedPerson + ":" }}</v-card-text>
                  </v-col>
                  <v-col cols="10" sm="10" md="3" xs="12" class="pa-2">
                    <v-text-field class="ma-0 pa-0" v-model="user.firstname" name="FirstName" :label="s_Name" :rules="global_rules.required" maxlength="30" required />
                  </v-col>
                  <v-col cols="10" sm="10" md="3" xs="12" class="pa-2">
                    <v-text-field class="ma-0 pa-0" v-model="user.middlename" name="MiddleName" :label="s_Surname" :rules="global_rules.required" maxlength="30" required></v-text-field>
                  </v-col>
                  <v-col cols="10" sm="10" md="4" xs="12" class="pa-2">
                    <v-text-field class="ma-0 pa-0" v-model="user.lastname" name="LastName" :label="s_LastName" :rules="global_rules.required" maxlength="30" required></v-text-field>
                  </v-col>
                  <v-col cols="10" class="pa-2">
                    <v-row class="ma-0 pa-0">
                      <v-simple-checkbox class="pr-3" :color="Colors.IconColor" v-model="agree" @click="dialogAgreement = agree" name="Agree" :ripple="false"></v-simple-checkbox>
                      <span class="subtitle-1" style="cursor: pointer" @click="dialogAgreement = true">
                        {{ s_IAccept }}
                        <span style="border-bottom-width: 1px; border-bottom-style: solid">{{ s_TheTermsOfUse }}</span
                        >{{ " " + s_AndIAgree }}
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
          <v-row class="ma-0 pb-3" align="center" justify="center">
            <v-col v-if="!isOnMobile" cols="10">
              <v-btn block :color="Colors.IconColor" class="white--text" @click="register()" :disabled="wait_login_timeout">{{ s_Registration }}</v-btn>
            </v-col>
            <v-col cols="10" class="ma-0 pa-0">
              <v-row justify="space-around" class="ma-0 pa-0">
                <v-btn text small class="font-weight-black" @click="goToLogin()" :color="Colors.IconColor">{{ s_Cancel }}</v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import router from "../../router";
import CapsTooltip from "../Controls/CapsTooltip";
import AgreementFile from "!raw-loader!../../assets/docs/agreement.html";
import { TR } from "../../main";
const imageFDRID = require("../../assets/docs/imageFDRID.png");

export default {
  components: {
    CapsTooltip,
  },
  data() {
    return {
      imageFDRID: imageFDRID,
      agree: false,
      dialogChooseType: false,
      dialogFDRID: false,
      dialogGoToLogin: false,
      dialogAgreement: false,
      agreementContent: null,
      wait_login_timeout: false,
      capsOn: false,
      valid: true,
      show1: false,
      firmsCount: 1,
      dirty: false,
      user: {
        username: "",
        password: "",
        confirmpassword: "",
        firstname: "",
        middlename: "",
        lastname: "",
        email: "",
        EIK: "",
        orgName: "",
        FALicense: "",
        FAOldPsw: "",
        eikSNFDrid: { eik: "", sn: "", fdrid: "" },
      },
      currentTab: 0,
      tabs: [
        {
          name: "Нов потребител",
          icon: "mdi-account-plus",
          description: "За нови потребители, които не са използвали услуги за дистанционно отчитане.\nАкаунтът ще бъде одобрен след получаване на декларация.",
        },

        {
          name: "Наблюдател (Счетоводител)",
          icon: "mdi-account-multiple-plus-outline",
          description: "Наблюдател е потребител, който може да разглежда данните за ФУ, но не може да ги редактира и да променя абонаментния им план (пр. счетоводител).",
        },
        // {
        //   name: "ФУВАС Администратор потребител",
        //   icon: "mdi-account-check",
        //   description: "За потребители, използвали ФУВАС Администратор.\nАкаунтът се одобрява автоматично след регистрация.",
        // },
      ],
      TR: TR,
      s_FDRID: TR.FDRID,
      s_DevSN: TR.DevSN,
      s_Registration: TR.Registration,
      s_AndIAgree: TR.AndIAgree,
      s_TheTermsOfUse: TR.TheTermsOfUse,
      s_IAccept: TR.IAccept,
      s_Name: TR.Name,
      s_Surname: TR.Surname,
      s_LastName: TR.LastName,
      s_CompanyName: TR.CompanyName,
      s_EIK: TR.EIK,
      s_Username: TR.Username,
      s_Email: TR.Email,
      s_RegistrationCancelConfirm: TR.RegistrationCancelConfirm,
      s_RegistrationDataAvailable: TR.RegistrationDataAvailable,
      s_MOLorAuthorizedPerson: TR.MOLorAuthorizedPerson,
      s_IAgree: TR.IAgree,
      s_IDoNotAgree: TR.IDoNotAgree,
      s_Attention: TR.Attention,
      s_Cancel: TR.Cancel,
      s_Yes: TR.Yes,
      s_No: TR.No,
      rules: {
        minPassLen: (v) => v.length >= 6 || "Къса парола",
        minFirmsCount: (v) => v >= 1 || "Поне една фирма",
        maxFirmsCount: (v) => v <= 15 || "Прекалено много фирми",
      },
    };
  },
  computed: {
    getFirmsCount() {
      return this.firmsCount;
    },
  },
  methods: {
    isCapsOn(e) {
      this.capsOn = this.isCapsLockOn(e);
    },
    register() {
      if (this.wait_login_timeout) {
        return;
      }
      if (this.user.oCuserCompanyName) this.user.oCuserCompanyName = this.user.oCuserCompanyName.toTitleCase();
      this.user.firstname = this.user.firstname.trim().toTitleCase();
      this.user.middlename = this.user.middlename.trim().toTitleCase();
      this.user.lastname = this.user.lastname.trim().toTitleCase();
      this.$nextTick(() => {
        if (!this.agree) {
          this.dialogLoader.showError("Не можете да се регистрирате без да приемете Общите условия!", { location: "center" });
          return;
        }
        if (!this.$refs || !this.$refs.refRegistrationForm || !this.$refs.refRegistrationForm.validate()) {
          return;
        }
        this.wait_login_timeout = true;
        var clone = {};
        Object.assign(clone, this.user);
        if (this.currentTab == 0) {
          delete clone.FALicense;
          delete clone.FAOldPsw;
          clone.eikSNFDrid.sn = clone.eikSNFDrid.sn.trim();
          clone.eikSNFDrid.eik = clone.eikSNFDrid.eik.trim();
          clone.eikSNFDrid.fdrid = clone.eikSNFDrid.fdrid.trim();
          clone.EIK = clone.eikSNFDrid.eik.trim();
        } else if (this.currentTab == 1) {
          delete clone.FALicense;
          delete clone.FAOldPsw;
          delete clone.eikSNFDrid;
          // clone.EIK = "O" + clone.EIK;
          clone.observerCuser = true;
        } else if (this.currentTab == 2) {
          delete clone.eikSNFDrid;
          clone.IsFuvasAdminExistingUser = true;
        }
        DataManager.register(clone, (err) => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            router.push({ path: "/login", params: { propusername: clone.username, proppassword: clone.password } });
            this.dialogLoader.showInfo("Успешна регистрация.");
          } else {
            var msg = "Грешка!\n" + err.Message;
            if (err.ErrorDetails) {
              err.ErrorDetails.forEach((d) => (msg += "\n" + d.Description));
            }
            this.dialogLoader.showError(msg, { location: "center" });
          }
          setTimeout(() => {
            this.wait_login_timeout = false;
          }, 3000);
        });
      });
    },
    selectTab(idx) {
      this.currentTab = idx;
      this.dialogChooseType = false;
      if (this.currentTab == 1) {
        this.dialogLoader.showInfo(
          "Ролята 'Наблюдател' е предназначена за фирми, които не са собственици на фискални устройства.\nФирмата 'Наблюдател' трябва да бъде оторизирана чрез профила на собственика на ФУ, за да може да наблюдава данните му.\nНай-честото приложение на ролята 'Наблюдател' са счетоводните фирми на собствениците на ФУ.",
          { timeout: 15000 }
        );
      }
      // this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.$refs.refRegistrationForm) this.$refs.refRegistrationForm.resetValidation();
      });
      // });
    },
    cancelDialog(agree) {
      this.dialogAgreement = false;
      this.agree = agree;
    },
    goToLogin(force) {
      if (force) {
        this.dialogGoToLogin = false;
        this.dirty = false;
      }
      if (this.dirty) {
        this.dialogGoToLogin = true;
      } else {
        router.push({ path: "/login" }).catch(() => {});
      }
    },
  },
  watch: {
    user: {
      handler() {
        this.dirty = true;
      },
      deep: true,
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.$nextTick(() => {
          this.booleans.isLoading = false;
        });
      }
    };
    this.agreementContent = AgreementFile;
    if (this.$route.query.sn || this.$route.query.SN || this.$route.query.eik || this.$route.query.EIK) {
      this.user.eikSNFDrid.sn = this.$route.query.sn ?? this.$route.query.SN;
      this.user.eikSNFDrid.eik = this.$route.query.eik ?? this.$route.query.EIK;
      this.user.eikSNFDrid.fdrid = this.$route.query.fdrid ?? this.$route.query.FDRID;
    }
    if (this.$route.query.FALicense || this.$route.query.falicense) {
      this.user.FALicense = this.$route.query.FALicense ?? this.$route.query.falicense;
      this.selectTab(0);
    } else {
      this.$nextTick(() => {
        this.dialogChooseType = true;
      });
    }
  },
};
</script>

<style scoped>
.custom-tooltip {
  white-space: pre-line;
  max-width: 330px;
  padding: 10px;
  margin: 0;
  opacity: 1 !important;
}
</style>